import React, { PropsWithChildren } from "react";

import Button from "../../../../../../../components/Button";
// components
import ContentModal from "../../../../../../../components/Modal/Templates/ContentModal";
import Spacer from "../../../../../../../components/Spacer";
import Typography from "../../../../../../../components/Text";

// css
import css from "./ArchiveGoalsModal.module.scss";

type ArchiveGoalModalProps = {
	numberOfGoals: number;
	onClose?: () => void;
	onUpdate?: () => void;
};

const ArchiveGoalModal = ({ numberOfGoals = 0, onClose, onUpdate }: PropsWithChildren<ArchiveGoalModalProps>) => {
	if (onUpdate && onClose) {
		return (
			<ContentModal
				size="large"
				handleClose={onClose}
				buttons={[
					<Button size="large" key="negative" color="blue" onClick={onClose}>
						Cancel
					</Button>,
					<Button
						size="large"
						key="positive"
						color="green"
						onClick={() => {
							onUpdate();
							onClose();
						}}
					>
						Yes, Archive Goal{numberOfGoals !== 1 ? "s" : ""}
					</Button>,
				]}
			>
				<div className={css.contentContainer}>
					<div className={css.content}>
						<Typography size="paragraph-1" weight="semi-bold">
							Performing this action will archive {numberOfGoals} goal{numberOfGoals !== 1 ? "s" : ""}.
							Are you sure you want to proceed?
						</Typography>
						<Spacer height={2} />
						<Typography size="paragraph-3" weight="regular">
							Archived goals will lose their alignment
						</Typography>
						<Spacer height={1} />
						<Typography size="paragraph-3" weight="regular">
							Previously archived goals will remain archived.
						</Typography>
					</div>
				</div>
			</ContentModal>
		);
	}
};

export default ArchiveGoalModal;
